<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace" id="ded"> </p>
<p class="ded">For Ros</p>
<p class="linespace"> </p>
<p class="ded">and with special thanks to Anni Holmes, with whom I climbed Mount Nyangani, Zimbabwe, on 8th February 1990, and came down again safely.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?13b407f2